import React, { useContext } from 'react';
import { LanguageContext } from '../../App';

const translations = {
  en: {
    title: 'Our Blog',
    subtitle: 'Stories of hope, change, and community service',
    readMore: 'Read More'
  },
  hi: {
    title: 'हमारा ब्लॉग',
    subtitle: 'आशा, परिवर्तन और समाज सेवा की कहानियां',
    readMore: 'और पढ़ें'
  }
};

const blogPosts = {
  en: [
    {
      id: 1,
      title: 'The Power of Community Service',
      excerpt: 'Discover how community service can transform lives and create lasting change...',
      image: '/images/blog1.jpg',
      date: 'March 20, 2024'
    },
    {
      id: 2,
      title: 'Education: A Path to Empowerment',
      excerpt: 'Learn about our initiatives to provide quality education to underprivileged children...',
      image: '/images/blog2.jpeg',
      date: 'March 15, 2024'
    },
    {
      id: 3,
      title: 'Healthcare for All',
      excerpt: 'Our mission to make healthcare accessible to everyone in need...',
      image: '/images/blog3.jpg',
      date: 'March 10, 2024'
    }
  ],
  hi: [
    {
      id: 1,
      title: 'समाज सेवा की शक्ति',
      excerpt: 'जानें कैसे समाज सेवा जीवन को बदल सकती है और स्थायी परिवर्तन ला सकती है...',
      image: '/images/blog1.jpg',
      date: '20 मार्च 2024'
    },
    {
      id: 2,
      title: 'शिक्षा: सशक्तिकरण का मार्ग',
      excerpt: 'वंचित बच्चों को गुणवत्तापूर्ण शिक्षा प्रदान करने के हमारे प्रयासों के बारे में जानें...',
      image: '/images/blog2.jpeg',
      date: '15 मार्च 2024'
    },
    {
      id: 3,
      title: 'सभी के लिए स्वास्थ्य सेवा',
      excerpt: 'जरूरतमंद लोगों के लिए स्वास्थ्य सेवा को सुलभ बनाने का हमारा मिशन...',
      image: '/images/blog3.jpg',
      date: '10 मार्च 2024'
    }
  ]
};

const Blog: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const posts = blogPosts[language];

  return (
    <div className="py-12 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">{t.title}</h1>
          <p className="text-xl text-gray-600">{t.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="aspect-w-16 aspect-h-9">
                <img
                  src={post.image}
                  alt={post.title}
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="p-6">
                <p className="text-gray-500 text-sm mb-2">{post.date}</p>
                <h2 className="text-xl font-bold mb-3">{post.title}</h2>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <button className="text-primary font-semibold hover:text-primary/80 transition-colors">
                  {t.readMore}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog; 